import { User } from '@src/types/User';
import useApiMutation from '@src/hooks/useApiMutation';

export default (userId: string) =>
  useApiMutation<null, User>({
    apiPath: `/users/${userId}`,
    method: 'DELETE',
    useV2API: true,
  });
